<script setup>
defineProps({
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['click']);

const handleClick = () => {
    emit('click');
};
</script>

<template>
    <Button
        severity="secondary"
        icon="pi pi-save text-sm"
        size="small"
        :disabled="disabled"
        @click="handleClick"
        class="btn-rascunho w-full md:w-auto"
        :pt="{
            root: { class: 'surface-100 hover:surface-200 text-sm border-0 border-round-3xl' },
            icon: { class: 'text-500 text-sm' }
        }">
        <template #default>
            <i class="pi pi-save text-sm text-600"></i>
            <span class="label-rascunho font-medium text-600 text-xs">Salvar como Rascunho</span>
        </template>
    </Button>
</template>

<style scoped>
/* Botão Salvar Rascunho com animação */
.btn-rascunho :deep(.p-button) {
    overflow: hidden;
    transition: all 0.3s ease;
}

.btn-rascunho .label-rascunho {
    max-width: 0;
    opacity: 0;
    overflow: hidden;
    white-space: nowrap;
    transition: max-width 0.3s ease, opacity 0.3s ease, margin-left 0.3s ease;
    display: inline-block;
    margin-left: 0;
}

.btn-rascunho:hover .label-rascunho {
    max-width: 180px;
    opacity: 1;
    margin-left: 12px;
}

/* No mobile sempre mostra o texto */
@media (max-width: 768px) {
    .btn-rascunho .label-rascunho {
        max-width: 180px;
        opacity: 1;
        margin-left: 12px;
    }
}
</style>
